import type { IconData } from '@stacksjs/iconify-core'

export const computersDevicesElectronicsGraphicTablet: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 12.19H32v18.29h-1.52ZM1.52 30.48h28.96V32H1.52Zm6.1-16.76v15.24h21.33V13.72Zm19.81 13.71H9.14V15.24h18.29Z\"/><path fill=\"currentColor\" d=\"M25.91 22.86h-1.53v1.52h-1.52v1.53h3.05zm-1.53-3.05h1.53v-3.05h-3.05v1.53h1.52zm-10.67 4.57h-1.52v-1.52h-1.52v3.05h3.04zm-1.52-6.09h1.52v-1.53h-3.04v3.05h1.52zM10.67 3.05h1.52V6.1h-1.52ZM7.62 1.53h3.05v1.52H7.62ZM6.1 6.1h4.57v1.52H6.1Zm0-6.1h1.52v1.53H6.1ZM3.05 27.43H6.1v1.53H3.05Zm0-3.05H6.1v1.53H3.05Zm0-4.57H6.1v3.05H3.05Zm0-3.05H6.1v1.53H3.05Zm0-3.04H6.1v1.52H3.05Zm27.43-1.53v-1.52H6.1V7.62H4.57v3.05H1.52v1.52zM0 12.19h1.52v18.29H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computersDevicesElectronicsGraphicTablet
